import { Box } from '@mui/material';
import { getThumbnailTileStyle } from 'Config/featureFlags';
import styles from './index.module.css';

// `hideTitle` is intentionally accepted but unused — titles are no longer
// hidden in any mode (gift / non-gift). Prop kept in the signature so the
// many call sites that still pass `hideTitle={hideVideoTitles}` keep
// compiling without code churn.
// eslint-disable-next-line no-unused-vars
export function TitleLabel({ title, category, hideTitle }) {
    // Titles adapt to the tile style (read at render from localStorage):
    //   adaptive/poster/framed → truncate to the TILE width (not a fixed char count).
    //   framed                 → stacked title/category column BESIDE the thumbnail.
    //   cinematic              → title is drawn ON the thumbnail, so none below.
    //   letterbox              → original fixed 17ch cap.
    const style = getThumbnailTileStyle();
    if (style === 'cinematic') return null;
    const IS_ADAPTIVE = style === 'adaptive';
    const IS_POSTER = style === 'poster';
    const IS_FRAMED = style === 'framed';
    const FIT_TITLE = IS_ADAPTIVE || IS_POSTER || IS_FRAMED;
    // eslint-disable-next-line no-nested-ternary
    const boxClass = IS_FRAMED ? styles.titleBoxFramed : (IS_ADAPTIVE ? styles.titleBoxAdaptive : undefined);
    return (
        <Box
          className={boxClass}
          display="flex"
          flexDirection={IS_FRAMED ? 'column' : 'row'}
          justifyContent={IS_FRAMED ? 'center' : 'space-between'}
          alignItems={IS_FRAMED ? 'flex-start' : 'center'}
          m="2px"
        >

            <h4 style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              // Legacy: cap at 17ch. Every new style fills the tile width and
              // truncates there (minWidth:0 lets the flex item actually shrink).
              maxWidth: FIT_TITLE ? '100%' : '17ch',
              minWidth: FIT_TITLE ? 0 : undefined,
              zIndex: 1,
              margin: '0px',
              // Match the category/row-heading typeface (Montserrat, tight
              // tracking) so card titles read as the same family, just smaller.
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '14px',
              fontWeight: 700,
              letterSpacing: '-0.01em'
            }}
            >
              {title}
            </h4>
            {
                category
            && <h6 style={{ margin: '0px', color: 'white' }}>{category}</h6>
            }

        </Box>
    );
}
